var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bj-unit-schedule-tour" }, [
    _vm.isLoadingSlots
      ? _c(
          "div",
          { staticClass: "text-center q-py-lg" },
          [_c("q-spinner-puff", { attrs: { color: "primary", size: "52px" } })],
          1
        )
      : _c(
          "div",
          [
            !_vm.dateOptions.length
              ? _c("div", { staticClass: "text-grey-7 q-mb-sm" }, [
                  _vm._v("\n      No showing slots are available.\n    ")
                ])
              : [
                  _c("div", { staticClass: "slot-section q-mb-md" }, [
                    _c("div", { staticClass: "slot-section-header q-mb-sm" }, [
                      _c(
                        "div",
                        { staticClass: "slot-section-label text-grey-7" },
                        [_vm._v("\n            Day\n          ")]
                      ),
                      _vm.chosenDateOption
                        ? _c("div", { staticClass: "slot-section-chosen" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.chosenDateSummary) +
                                "\n          "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      { staticClass: "row gutter-sm slot-grid" },
                      _vm._l(_vm.dateOptions, function(dateOption) {
                        return _c(
                          "div",
                          {
                            key: dateOption.date,
                            staticClass: "col-2 q-mb-sm"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "slot-card date-option",
                                class: {
                                  chosen:
                                    _vm.chosenDateOption &&
                                    _vm.chosenDateOption.date ===
                                      dateOption.date
                                },
                                attrs: {
                                  type: "button",
                                  disabled: dateOption.disabled
                                },
                                on: {
                                  click: function($event) {
                                    _vm.chooseDate(dateOption)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "month" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(dateOption.month) +
                                      "\n              "
                                  )
                                ]),
                                _c("div", { staticClass: "day-row" }, [
                                  _c("div", { staticClass: "day-of-month" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(dateOption.dayOfMonth) +
                                        "\n                "
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "day-of-month-ordinal" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(dateOption.dayOfMonthOrdinal) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "day-of-week" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(dateOption.dayOfWeek) +
                                      "\n              "
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      })
                    )
                  ]),
                  _vm.chosenDateOption
                    ? _c("div", { staticClass: "slot-section" }, [
                        _c(
                          "div",
                          { staticClass: "slot-section-header q-mb-sm" },
                          [
                            _c(
                              "div",
                              { staticClass: "slot-section-label text-grey-7" },
                              [_vm._v("\n            Time\n          ")]
                            ),
                            _vm.chosenTimeOption
                              ? _c(
                                  "div",
                                  { staticClass: "slot-section-chosen" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.chosenTimeOption.time) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "q-mb-sm flex justify-center mb-4" },
                          [
                            _c(
                              "q-btn-group",
                              { attrs: { outline: "" } },
                              [
                                _c("q-btn", {
                                  attrs: {
                                    size: "sm",
                                    disable: _vm.isAvailableTimesButtonDisabled,
                                    color: _vm.showAllSlots
                                      ? "grey-7"
                                      : "primary",
                                    outline: _vm.showAllSlots,
                                    label: "Available times"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.showAllSlots = false
                                    }
                                  }
                                }),
                                _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      size: "sm",
                                      color: _vm.showAllSlots
                                        ? "primary"
                                        : "grey-7",
                                      outline: !_vm.showAllSlots,
                                      label: "All times"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showAllSlots = true
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "q-tooltip",
                                      {
                                        attrs: {
                                          anchor: "top middle",
                                          self: "bottom middle"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Also show blocked and constrained times that you can override\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.isLoadingDateSlots
                          ? _c(
                              "div",
                              { staticClass: "text-center q-py-md" },
                              [
                                _c("q-spinner-puff", {
                                  attrs: { color: "primary", size: "32px" }
                                })
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "row gutter-sm slot-grid slot-grid-time"
                              },
                              [
                                _vm._l(_vm.timeOptions, function(timeOption) {
                                  return _c(
                                    "div",
                                    {
                                      key: timeOption.datetime,
                                      staticClass: "col-2 q-mb-sm"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "slot-card time-option",
                                          class: {
                                            chosen:
                                              _vm.chosenTimeOption &&
                                              _vm.chosenTimeOption.datetime ===
                                                timeOption.datetime,
                                            overridable:
                                              timeOption.slot_state ===
                                              "overridable",
                                            blocked:
                                              timeOption.slot_state ===
                                              "blocked"
                                          },
                                          attrs: {
                                            type: "button",
                                            disabled: timeOption.disabled
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.chooseTime(timeOption)
                                            }
                                          }
                                        },
                                        [
                                          _c("div", { staticClass: "time" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(timeOption.time) +
                                                "\n                "
                                            ),
                                            timeOption.tooltip &&
                                            timeOption.tooltip.length
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tooltip-indicator"
                                                  },
                                                  [
                                                    _c("q-icon", {
                                                      attrs: {
                                                        name: "info",
                                                        size: "14px"
                                                      }
                                                    }),
                                                    _c(
                                                      "q-tooltip",
                                                      {
                                                        attrs: {
                                                          anchor: "top middle",
                                                          self: "bottom middle",
                                                          delay: 450
                                                        }
                                                      },
                                                      _vm._l(
                                                        timeOption.tooltip,
                                                        function(line, index) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "tooltip-" +
                                                                timeOption.datetime +
                                                                "-" +
                                                                index,
                                                              staticClass:
                                                                "q-mb-xs"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(line) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                !_vm.timeOptions.length
                                  ? _c(
                                      "div",
                                      { staticClass: "col-12 text-grey-7" },
                                      [
                                        _vm._v(
                                          "\n            No times are available for the selected day.\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                      ])
                    : _vm._e()
                ],
            _vm.warningsRef.length ||
            _vm.restrictionWarningsRef.length ||
            _vm.assigneeMismatchWarningDataRef
              ? _c(
                  "div",
                  { staticClass: "q-mt-sm" },
                  [
                    _c("p", { staticClass: "text-weight-medium q-mb-xs" }, [
                      _vm._v("\n        Warnings\n      ")
                    ]),
                    _vm._l(_vm.warningsRef, function(warning, index) {
                      return _c(
                        "p",
                        { key: "warning-" + index, staticClass: "q-mb-xs" },
                        [_vm._v("\n        " + _vm._s(warning) + "\n      ")]
                      )
                    }),
                    _vm.restrictionWarningsRef.length ||
                    _vm.assigneeMismatchWarningDataRef
                      ? _c(
                          "ul",
                          { staticClass: "q-pl-md q-mb-none" },
                          [
                            _vm.assigneeMismatchWarningDataRef
                              ? _c("li", { staticClass: "q-mb-xs" }, [
                                  _vm._v(
                                    "\n          There are already\n          "
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.assigneeMismatchWarningDataRef
                                          .leadCount
                                      )
                                    )
                                  ]),
                                  _vm._v(
                                    "\n          prospects scheduled to tour the property at that time with\n          "
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.assigneeMismatchWarningDataRef
                                          .slotAssigneeName
                                      )
                                    )
                                  ]),
                                  _vm._v(
                                    ".\n          The new prospect will be added and the tour will be re-assigned to\n          "
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.assigneeMismatchWarningDataRef
                                          .chosenAssigneeLabel
                                      )
                                    )
                                  ]),
                                  _vm._v(".\n        ")
                                ])
                              : _vm._e(),
                            _vm._l(_vm.restrictionWarningsRef, function(
                              line,
                              index
                            ) {
                              return _c(
                                "li",
                                {
                                  key: "restriction-" + index,
                                  staticClass: "q-mb-xs"
                                },
                                [
                                  _vm._v(
                                    "\n          " + _vm._s(line) + "\n        "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }